import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomDialog from "../common/Dialog";
import ConfirmDialoag from "../common/ConfirmDialoag";
import Loader from "../../Layout/Loader";
import Button from "../common/Button";
import TextField from "../common/TextField";
import instance from "../../axios";
import { errorHandler } from "../../Helpers";
import { notifySuccess } from "../../Utils/CustomNotifcations";

const formDefaultState = {
  categoryName: "",
};

const MODAL_WIDTH = 560;
const MODAL_CONTENT_HEIGHT = 420;

const categoryDataFormat = (data, id, parentId) => ({
  id: id || 0,
  categoryName: data?.categoryName ? data.categoryName.trim() : "",
  parentId: parentId || 0,
  archive: data?.archive || false,
  archiveTime: data?.archiveTime || null,
});

class VehicleCategoryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 50,
      itemSearch: "",
      view: "list",
      tableData: [],
      form: { ...formDefaultState },
      selectedCategory: null,
      loading: false,
      saving: false,
      onDeleteConfirmation: false,
    };
  }

  componentDidMount() {
    this.getCategories();
  }

  getCategories = () => {
    const { page, pageSize, itemSearch } = this.state;
    if (!this.props.logInUser?.id) return;

    this.setState({ loading: true });
    instance(
      `/api/vehiclecategorys/get?page=${page}&limit=${pageSize}&category=${itemSearch || ""}`,
    )
      .then((response) => {
        this.setState({
          tableData: response?.data || [],
          loading: false,
        });
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
        this.setState({ loading: false });
      });
  };

  handleSearch = (e) => {
    const value = e.target.value;
    this.setState({ itemSearch: value, page: 1 }, () => this.getCategories());
  };

  showList = () => {
    this.setState({
      view: "list",
      form: { ...formDefaultState },
      selectedCategory: null,
    });
  };

  showAddForm = () => {
    this.setState({
      view: "form",
      form: { ...formDefaultState },
      selectedCategory: null,
    });
  };

  showEditForm = (item) => {
    this.setState({
      view: "form",
      selectedCategory: item,
      form: { categoryName: item.categoryName || "" },
    });
  };

  handleChange = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        categoryName: e.target.value,
      },
    });
  };

  handleSubmit = () => {
    const { form, selectedCategory } = this.state;
    if (!form.categoryName?.trim()) return;

    const parentId = this.props.logInUser?.id || 0;
    const isEdit = Boolean(selectedCategory?.id);
    const url = isEdit
      ? `/api/vehiclecategorys/${selectedCategory.id}`
      : "/api/vehiclecategorys";
    const body = categoryDataFormat(
      form,
      isEdit ? selectedCategory.id : 0,
      parentId,
    );

    this.setState({ saving: true });

    instance({
      url,
      method: isEdit ? "PUT" : "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: body,
    })
      .then(() => {
        this.props.dispatch(
          notifySuccess(isEdit ? "updatedSuccessfully" : "createdSuccessfully"),
        );
        this.setState(
          {
            saving: false,
            view: "list",
            form: { ...formDefaultState },
            selectedCategory: null,
          },
          () => {
            this.getCategories();
            if (this.props.onCategoriesUpdated) {
              this.props.onCategoriesUpdated();
            }
          },
        );
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
        this.setState({ saving: false });
      });
  };

  confirmDelete = (item) => {
    this.setState({
      onDeleteConfirmation: true,
      selectedCategory: item,
    });
  };

  deleteItem = () => {
    const { selectedCategory } = this.state;
    if (!selectedCategory?.id) return;

    this.setState({ saving: true });

    instance({
      url: `/api/vehiclecategorys/${selectedCategory.id}`,
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        this.props.dispatch(notifySuccess("deletedSuccessfully"));
        this.setState(
          {
            saving: false,
            onDeleteConfirmation: false,
            selectedCategory: null,
          },
          () => {
            this.getCategories();
            if (this.props.onCategoriesUpdated) {
              this.props.onCategoriesUpdated();
            }
          },
        );
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
        this.setState({ saving: false, onDeleteConfirmation: false });
      });
  };

  onCancelDelete = () => {
    this.setState({ onDeleteConfirmation: false, selectedCategory: null });
  };

  renderListView() {
    const { translate } = this.props;
    const { tableData, loading, saving } = this.state;

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: MODAL_WIDTH,
          maxWidth: "100%",
          p: 2,
          boxSizing: "border-box",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1.5}
          flexWrap="wrap"
          gap={1}
          flexShrink={0}
        >
          <TextField
            label={translate("search")}
            value={this.state.itemSearch}
            onChange={this.handleSearch}
            style={{ minWidth: 180, flex: 1 }}
          />
          <Button size="small" onClick={this.showAddForm} disabled={saving}>
            <AddIcon fontSize="small" style={{ marginRight: 4 }} />
            {translate("create")}
          </Button>
        </Box>

        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
          {loading ? (
            <Loader />
          ) : tableData.length === 0 ? (
            <Box textAlign="center" py={3} color="text.secondary">
              {translate("noCategoriesFound")}
            </Box>
          ) : (
            <TableContainer
              sx={{
                height: "100%",
                maxHeight: MODAL_CONTENT_HEIGHT - 72,
                overflow: "auto",
                border: "1px solid #e0e0e0",
                borderRadius: 1,
              }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: 600, backgroundColor: "#fafafa" }}
                    >
                      {translate("categoryName")}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 600,
                        backgroundColor: "#fafafa",
                        width: 100,
                      }}
                    >
                      {translate("actions")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell>{row.categoryName}</TableCell>
                      <TableCell align="right">
                        <Tooltip title={translate("sharedEdit")}>
                          <IconButton
                            size="small"
                            onClick={() => this.showEditForm(row)}
                            disabled={saving}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={translate("delete")}>
                          <IconButton
                            size="small"
                            onClick={() => this.confirmDelete(row)}
                            disabled={saving}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Box>
    );
  }

  renderFormView() {
    const { translate } = this.props;
    const { form, selectedCategory, saving } = this.state;
    const isEdit = Boolean(selectedCategory?.id);

    return (
      <Box
        sx={{
          width: MODAL_WIDTH,
          maxWidth: "100%",
          p: 2,
          boxSizing: "border-box",
        }}
      >
        <Box display="flex" alignItems="center" mb={2}>
          <IconButton size="small" onClick={this.showList} disabled={saving}>
            <ArrowBackIcon fontSize="small" />
          </IconButton>
          <span style={{ marginLeft: 8, fontWeight: 500 }}>
            {translate(isEdit ? "editCategory" : "addCategory")}
          </span>
        </Box>
        <TextField
          id="categoryName"
          label={translate("categoryName")}
          value={form.categoryName}
          onChange={this.handleChange}
          variant="outlined"
          margin="dense"
          fullWidth
          required
          disabled={saving}
        />
        <Box display="flex" justifyContent="flex-end" mt={2} gap={1}>
          <Button
            variant="outlined"
            size="small"
            onClick={this.showList}
            disabled={saving}
          >
            {translate("sharedCancel")}
          </Button>
          <Button
            size="small"
            onClick={this.handleSubmit}
            disabled={saving || !form.categoryName?.trim()}
          >
            {translate(isEdit ? "update" : "sharedCreate")}
          </Button>
        </Box>
        {saving && <Loader />}
      </Box>
    );
  }

  render() {
    const { translate, onClose } = this.props;
    const { view } = this.state;

    return (
      <>
        <CustomDialog
          title={translate("manageVehicleTypes")}
          onClose={onClose}
          disableFooter
          noFullScreen
          maxWidth={false}
          dialogHeight={`${MODAL_CONTENT_HEIGHT}px`}
          bodyPadding={0}
        >
          {view === "list" ? this.renderListView() : this.renderFormView()}
        </CustomDialog>

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancelDelete}
            onOk={this.deleteItem}
            title={translate("areYouWantToDelete")}
            children={this.state.selectedCategory?.categoryName}
          />
        )}
      </>
    );
  }
}

const mapState = (state) => ({
  logInUser: state.logInUsers,
  themecolors: state.themeColors,
});

export default connect(mapState)(VehicleCategoryModal);
